/** One titled block of an editor form, ruled off from the next. */
import type { ReactNode } from 'react';

export interface EditorFormSectionProps {
  title: string;
  hint: string;
  /** The id of the title, for the controls inside to be labelled by. */
  titleId: string;
  hintId?: string;
  last?: boolean;
  children: ReactNode;
}

export function EditorFormSection(p: EditorFormSectionProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        paddingBottom: p.last ? 0 : 20,
        marginBottom: p.last ? 0 : 20,
        borderBottom: p.last ? 'none' : '1px solid var(--nb-border)',
      }}
    >
      <div>
        <h3
          id={p.titleId}
          style={{ margin: 0, fontSize: 14, fontWeight: 800, color: 'var(--nb-ink)' }}
        >
          {p.title}
        </h3>
        <div id={p.hintId} style={{ fontSize: 12, color: 'var(--nb-subtle)', marginTop: 2 }}>
          {p.hint}
        </div>
      </div>
      {p.children}
    </div>
  );
}
